import { Card, CardContent } from "@dune/ui";
import React from "react";

interface ReceiptsCardProps {
	totalCount?: number;
	isLoading?: boolean;
	error?: Error | null;
}

export const ReceiptsCard: React.FC<ReceiptsCardProps> = ({
	totalCount,
	isLoading = false,
	error = null,
}) => {
	if (isLoading) {
		return (
			<Card className="bg-gray-50 rounded-lg border border-gray-100" noShadow>
				<CardContent className="flex items-center space-x-4">
					<div className="flex flex-row items-center gap-2 text-orange-badge-text">
						<div className="font-semibold">Quittances à régler</div>
						<div className="border border-orange-badge-border bg-orange-badge-background rounded-full px-2 py-1">
							...
						</div>
					</div>
				</CardContent>
			</Card>
		);
	}

	if (error) {
		return (
			<Card className="bg-gray-50 rounded-lg border border-gray-100" noShadow>
				<CardContent className="flex items-center space-x-4">
					<div className="flex flex-row items-center gap-2 text-red-600">
						<div className="font-semibold">Erreur quittances</div>
					</div>
				</CardContent>
			</Card>
		);
	}

	const count = totalCount || 0;

	return (
		<Card className="bg-gray-50 rounded-lg border border-gray-100" noShadow>
			<CardContent className="flex items-center space-x-4">
				<div className="flex flex-1 flex-row items-center gap-2 text-orange-badge-text justify-between ">
					<div className="font-semibold">Quittances à régler</div>
					<div className="border border-orange-badge-border bg-orange-badge-background rounded-full px-2 py-1">
						{count}
					</div>
				</div>
			</CardContent>
		</Card>
	);
};
